import dynamic from "next/dynamic";

import { ZapHistoryExportFormat } from "@zapier/reporting/src/graphql-types";
import { ModalState } from "./useZapRunModals";

const DeleteModal = dynamic(() => import("./DeleteModal"));
const DownloadRunsModal = dynamic(() => import("./DownloadRunsModal"));
const ErrorModal = dynamic(() => import("./ErrorModal"));
const ReplayModal = dynamic(() => import("../../global/ReplayModal"));

interface Props {
  closeModal: () => void;
  confirmDownloadRuns: (
    format: ZapHistoryExportFormat,
    excludeChildren: boolean
  ) => Promise<void>;
  modal: ModalState;
}

export function ZapRunModals({
  closeModal,
  confirmDownloadRuns,
  modal,
}: Props) {
  if (modal.kind === "delete") {
    return <DeleteModal onClose={closeModal} onDelete={modal.onDelete} />;
  }

  if (modal.kind === "download") {
    return (
      <DownloadRunsModal
        isAllSelected={modal.selection.isAllSelected}
        onCanceled={closeModal}
        onConfirmed={confirmDownloadRuns}
      />
    );
  }

  if (modal.kind === "replay") {
    return (
      <ReplayModal
        allowTaskReplay={modal.allowTaskReplay}
        onClose={closeModal}
        onReplay={modal.onReplay}
      />
    );
  }

  if (modal.kind === "error") {
    return <ErrorModal error={modal.error} onClose={closeModal} />;
  }

  return null;
}
